import Image from "next/image";
import { useRouter } from "next/router";

function Hero() {
  const { locale } = useRouter();
  const src =
    locale === "ar" ? "/about-us-hero-arabic.svg" : "/about-us-hero.svg";

  return (
    <div className="bg-terryWhite w-screen relative -mb-2 md:mt-24 mt-10">
      <Image
        src={src}
        alt="team"
        width={1920}
        height={1080}
        className="w-full h-[63vw] md:h-auto object-cover md:object-fill md:object-center object-left"
        priority={true}
      />
    </div>
  );
}

export default Hero;
